{
  "fr": {
    "onboardingGroups": {
      "edit": {
        "heading": "Avez-vous déjà accès à un groupe de licences via votre établissement ?",
        "paragraph": "Si oui, vous pouvez activer l'accès ici. Vous recevrez le code de la personne de contact de votre établissement.",
        "skip": "Continuer sans code",
        "autoSubmitting": "Activation de la licence en cours …",
        "joined": {
          "title": "Vous avez déjà rejoint un groupe de licence",
          "next": "Continuer",
          "description": "Vous êtes associé·e à l'école « {school} » via le code d'activation du groupe « {group} ». Si vous avez un autre code, vous pouvez le saisir ici."
        }
      }
    }
  }
}
